import { render, staticRenderFns } from "./trash-folder-empty.vue?vue&type=template&id=034bc874&"
import script from "./trash-folder-empty.vue?vue&type=script&lang=js&"
export * from "./trash-folder-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports